import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FilterBlock } from './filter-block/filter-block';
import { FiltersService } from './filters.service';
import { TranslateService } from '../../../shared/translate.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AuthService } from '../../../auth/auth.service';
import { MessageService } from '../../../messages/message.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserQueryComponent } from '../../../auth/account/user-queries/user-query/user-query.component';
import { UserQueriesService } from '../../../auth/account/user-queries/user-queries.service';
import { UserQueryDto, UserQueryDtoInterface } from '../../../auth/account/user-queries/dto/user-query-dto';
import { SearchService } from '../../search.service';
import { Filter } from './filter-block/filter-item/filter';
import { FilterItemComponent } from './filter-block/filter-item/filter-item.component'
import { AppUtils } from "../../../shared/app-utils";

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.css']
})
export class FiltersComponent implements OnInit, OnDestroy {

  groupedFilters: FilterBlock[] = [];

  filtersActive: boolean = false;

  sortActive: boolean = false;

  @Output() init = new BehaviorSubject<boolean>(false);

  refreshFilterEmitter = new EventEmitter<boolean>(false);

  logged: boolean = false;

  @Input() userQuery: UserQueryDtoInterface;

  @Input() collectionMode: boolean = false;

  private authSubscription: Subscription;

  constructor(
    private filterService: FiltersService, public translateService: TranslateService, private authService: AuthService,
    private messageService: MessageService, private modalService: NgbModal, private userQueryService: UserQueriesService,
    private searchService: SearchService, private filterItemComponent: FilterItemComponent) {
  }

  ngOnInit() {
    this.filterService.allRegularFacets.subscribe(filters => {
      this.init.next(this.init.value || filters.length > 0);
      const types = filters.filter(filter => filter.field == '_type').filter(filter => filter.selected);

      const tempGroupedFilters = [];
      this.filterService.getConfigs().forEach(filterConfig => {
        let filtersByField = this.filterService.getFiltersByField(filters, filterConfig.name);
        let childFiltersByField = this.filterService.getChildFilterBlocks(filterConfig.additionalConfigs, filters);
        if (this.filterService.canShow(filtersByField, filterConfig, types) && this.filterService.hasResults(filterConfig, childFiltersByField, filtersByField)) {
          tempGroupedFilters.push(new FilterBlock(filterConfig, filtersByField, childFiltersByField));
        }
      });

      this.updateOrRecreateFilters(tempGroupedFilters);
    });

    this.authSubscription = this.authService.isLogged.subscribe(logged => {
      this.logged = logged;
    });
  }

  ngOnDestroy(): void {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  updateOrRecreateFilters(tempGroupedFilters: FilterBlock[]) {
    if (this.groupedFilters.length == tempGroupedFilters.length) {
      for (let i = 0; i < tempGroupedFilters.length; i++) {
        if (this.groupedFilters[i].isDefault()) {
          this.groupedFilters[i].filters = tempGroupedFilters[i].filters;
          this.groupedFilters[i].childFilterBlocks = tempGroupedFilters[i].childFilterBlocks;
          this.groupedFilters[i].childFacetList = tempGroupedFilters[i].childFacetList;
        } else {
          this.groupedFilters[i] = tempGroupedFilters[i];
        }
      }
      this.refreshFilterEmitter.emit(true);
    } else {
      this.groupedFilters = tempGroupedFilters;
    }
  }

  toggleFilters() {
    this.filtersActive = !this.filtersActive;
  }

  toggleSort() {
    this.sortActive = !this.sortActive;
  }

  isYear(filterBlock: FilterBlock) {
    return filterBlock.filterConfig && filterBlock.filterConfig.renderer && filterBlock.filterConfig.renderer.startsWith('range');
  }

  preventDef(event) {
    if (event) {
      event.preventDefault();
    }
  }

  hideFiltersLabel() {
    return this.translateService.translate('filters.label');
  }

  openNewQueryModal() {
    this.logged ? this.openSaveModal() : this.messageService.errorMessage('', 'UserQuery.save.notLoggedIn');
  }

  userQuerySaveAction() {
    this.doSave(this.userQuery);
  }

  private openSaveModal() {
    this.modalService.open(UserQueryComponent).result.then(value => {
      if (value) {
        this.doSave(value);
      }
    });
  }

  private doSave(value) {
    this.authService.getToken().then(token => {
      value.itemsCount = this.searchService.searchList.totalHits;
      this.userQueryService.handleSaveUserQuery(value, token).then(userQueryDto => {
        this.userQuery = userQueryDto;
      });
    });
  }
}
